import React from "react";
import { Switch } from "@mui/material";

import { formatNumber } from "../../../utils/utils";
import { calculatePercentage } from "../utilization-utils";
import Accordian from "../../projects-list/project-details/project-health/components/accordian/accordian";
import ProgressBar from "../../projects-list/project-details/project-health/components/progress-bar/progress-bar";
import DepartmentMember from "./member";

const Department = ({
  department,
  deptData,
  expanded,
  toggleDepartmentState,
  setExpanded,
  toggleMemberState,
}) => {
  const { members, totalBillableHours, totalNonBillableHours, isActive } =
    deptData;

  const departmentPercentage = calculatePercentage(
    totalBillableHours,
    totalBillableHours + totalNonBillableHours
  );

  return (
    <Accordian
      key={department}
      name={department}
      handleChange={setExpanded}
      expanded={expanded}
      heading={
        <div className={`toggl ${!isActive ? "inactive" : ""}`}>
          <Switch
            checked={isActive}
            onClick={(e) => {
              e.stopPropagation();
              toggleDepartmentState(department);
            }}
          />
          <ProgressBar
            value={departmentPercentage}
            startLabel={`${department} (Billable / Non Billable)`}
            middleLabel={`${formatNumber(totalBillableHours)}h / ${formatNumber(
              totalNonBillableHours
            )}h`}
            endLabel={`${departmentPercentage}%`}
          />
        </div>
      }
      body={
        <div>
          {Object.entries(members).map(([memberKey, memberData]) => (
            <DepartmentMember
              key={memberKey}
              memberKey={memberKey}
              department={department}
              memberData={memberData}
              toggleMemberState={toggleMemberState}
            />
          ))}
        </div>
      }
    />
  );
};

export default Department;
